module.exports = __webpack_public_path__ + "img/outline-saving-green.d39ee20.svg";